<template>
  <div class="infinite-list-wrapper" style="overflow:auto">
    <ul class="list">
      <li v-for="(item, key) in tableData" :key="key" @click="itemClick(item)">
        <slot :item="item" :index="key" :header="header" :refresh.sync="refresh"></slot>
      </li>
    </ul>
    <p v-if="loading" class="loading-text"><i class="el-icon-loading"></i>拼命加载中...</p>
    <p v-if="noMore" class="nomore-text">
      <img v-if="noMore && currentPage === internalCurrentPage" src="@/assets/images/icon-nodata.png" alt="">
      {{ currentPage === internalCurrentPage ? '暂无数据' : '没有更多了' }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'DataList',
  data () {
    return {
      tableData: [],
      internalCurrentPage: 1,
      loading: false,
      noMore: false,
      header: [],
    };
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    searchData: {
      type: Object,
      default() {
        return {};
      }
    },
    postData: {
      type: Object,
      default() {
        return {};
      }
    },
    refresh: {
      type: [Boolean, Number],
      default: false
    },
    noPagination: {
      type: Boolean,
      default: false
    },
    inited: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    /**
       * 隐藏操作区域
       */
    hideOptArea: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    modifier: {
      type: Function,
      default: null
    },
    // 是否禁止下拉刷新
    refreshLock: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    disabled () {
      return !this.loading && !this.noMore;
    }
  },
  mounted() {
    this.internalPageSize = this.pageSize;
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    itemClick(item) {
      this.$emit('tapEvent', item);
    },
    handleScroll() {
      if (!this.refreshLock && !this.loading) {
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 变量windowHeight是可视区的高度
        let windowHeight = document.documentElement.clientHeight || document.body.clientHeight; // 变量scrollHeight是滚动条的总高度
        let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        if (scrollTop + windowHeight === scrollHeight && this.disabled) {
          // 请求数据接口
          this.doSearch(0);
          return false;
        }
      }
    },
    getTableData (
      currentPage = this.internalCurrentPage,
      pageSize = this.internalPageSize,
      amount = this.amount
    ) {
      // console.log('searchPage', this.internalCurrentPage, this.currentPage);
      if (this.internalCurrentPage === this.currentPage) {
        // 当页面为本次查询的第一页时清空页面所有数据===写两次是考虑上一次请求过快
        this.tableData = [];
      }
      this.loading = true;
      this.$http
        ._post({
          url: this.url + (this.noPagination ? '' : `?page=${currentPage}`),
          data: {
            ...this.postData,
            pageSize,
            amount,
            sortData: this.sortData,
            searchData: this.searchData
          }
        }).then(({ data }) => {
          if (this.internalCurrentPage === this.currentPage) {
            // 当页面为本次查询的第一页时清空页面所有数据
            this.tableData = [];
            window.scrollTo(0, 0);
          }
          if (!data.data || data.data.length === 0) {
            this.noMore = true;
          } else {
            data.data.forEach((item) => {
              this.tableData.push(item);
            });
          }
          this.header = data.header;
          this.loading = false;
          this.$emit('update:refresh', false);
        });
    },
    doSearch(page) {
      this.searching = true;
      if (!page) {
        this.internalCurrentPage++;
      } else {
        // 初始页查询
        this.internalCurrentPage = +page;
        this.noMore = false;
      }
      this.getTableData(this.internalCurrentPage);
    }
  },
  watch: {
    /* 监听刷新页面列表 */
    refresh(val) {
      if (val) {
        this.doSearch(this.currentPage);
      }
    },
  }
};
</script>
<style scoped>
  .infinite-list-wrapper ul li{
    background: #fff;
    border-radius: 2vw;
    margin-bottom: 3vw;
    padding: 5vw 4vw 0;
  }
  .loading-text, .nomore-text{
    text-align: center;
    padding: 4vw 0;
    color: #9a9a9a;
  }
  .nomore-text img{
    width:60%;
    max-width: 450px;
    display: block;
    margin: 2rem auto;
  }
</style>
